import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
import { useHead } from './hooks/useHead';
export function App() {
  useHead();
  useMetaPixel();
  return <div className="w-full bg-paper font-sans text-ink" data-id="element-0" data-mp="28s2ztflro5x1">
      <Hero data-id="element-1" data-mp="23ujmchww7x65" />
      <main data-id="element-2" data-mp="23ut9lxqjzq85">
        <ProblemSection data-id="element-3" data-mp="23t8fuac2cbbc" />
        <VolumesSection data-id="element-4" data-mp="3ik7gihlkcdr6" />
        <BonusesSection data-id="element-5" data-mp="3ikqwvtvkeu33" />
        <OfferSection data-id="element-6" data-mp="3ijfvg0pldyf5" />
        <GuaranteeSection data-id="element-7" data-mp="3ii4t85bsoyq5" />
        <TestimonialsSection data-id="element-8" data-mp="3mlatmwc87vop" />
        <ComparisonSection data-id="element-9" data-mp="3mk8710lxsfel" />
        <FaqSection data-id="element-10" data-mp="3mjg9hk8s47lo" />
        <FinalCtaSection data-id="element-11" data-mp="3rc9d24sih9w6" />
      </main>
      <Footer data-id="element-12" data-mp="3rdas0kcnegj6" />
      <StickyCta data-id="element-13" data-mp="3rcsy3udgkeef" />
    </div>;
}